module.exports = __webpack_public_path__ + "static/media/Folders.12daace3.svg";